module.exports = __webpack_public_path__ + "static/aboutus@2x-4ba2b0fe36c62d4866ce9c72d8eb8f32.png";